import React from 'react'
import { AppBar } from 'react-admin';

const LayoutAppBar = (props:any) => <AppBar {...props} color='primary' style={{ color: 'white' }}/>;
export default LayoutAppBar;
